import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
    id?: any;
    type: any;
    createdAt?: string;
    instituteDetails: any;
    productDetails?: any;
    stageId?: any;
    dealSize?: string;
    coverageDate?: string;
    comments?: string;
    coverageType?: string;
    voiceLink?: string;
    followUpDate?: any;
    institute?: any;
    stage?: any;
   // productDetails?: any;
    assignedUser?: any;
    contactDetails?: any;
    audioFileUrl?:any;
    coverageDetails?:any;
    lastCoverageDate?:any;
    assignedTo?: any;
    gstNo?: any
};

export const updateFunnel = ({ id,assignedTo, lastCoverageDate, type,productDetails,instituteDetails,stageId, coverageDate,coverageType,followUpDate,dealSize,audioFileUrl, contactDetails,coverageDetails, gstNo }: requestDTO) => {
  if(id){
    return axios.post(`/superadmin/update-funnel`, {id, assignedTo,lastCoverageDate,type,productDetails,instituteDetails,stageId, coverageDate,coverageType,followUpDate,dealSize,audioFileUrl,coverageDetails, contactDetails, gstNo});
  }else{
    return axios.post(`/superadmin/create-funnel`, { type,assignedTo, lastCoverageDate,productDetails,instituteDetails,stageId, coverageDate,coverageType,followUpDate,dealSize,audioFileUrl,coverageDetails, contactDetails, gstNo});
  }
};

type UseAddUserOptions = {
  config?: MutationConfig<typeof updateFunnel>;
};

export const useUpdateFunnel = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Funnel updated successfully',
      });
    },
    ...config,
    mutationFn: updateFunnel,
  });
};
